import { cloneDeep } from 'lodash-es';

import type { VitaFieldsData } from '@xing-com/crate-lebenslauf-graphql';
import type { CoverLetterDocumentType } from '@xing-com/crate-lebenslauf-shared-client-document-variable';

import type { EditProfessionalInformationFields } from '../types/SharedActions';

import { deserializeName } from './deserializeName';
import { updateLocalStorage } from './updateLocalStorage';

export const editProfessionalInformationFields = (
  doc: CoverLetterDocumentType,
  value: EditProfessionalInformationFields['value'],
  vitaFieldsData: VitaFieldsData
): void => {
  const { name, index, subIndex } = deserializeName(value.name);
  const { careerLevels, disciplines, industries } = vitaFieldsData;
  const professionalExperiencesOriginal = doc.professionalExperience;
  const professionalExperiences =
    cloneDeep(professionalExperiencesOriginal) || [];

  const fieldValue = value.value?.toString();

  if (index !== undefined) {
    const description = fieldValue;
    const experienceToUpdate = professionalExperiences[index];

    if (!experienceToUpdate) return;

    if (name === 'description' && subIndex !== undefined) {
      const descriptions = experienceToUpdate.descriptions ?? [];

      descriptions[subIndex] = {
        description,
      };
    } else if (name === 'jobLevel') {
      const id = fieldValue;
      const level = careerLevels.find((careerLevel) => careerLevel.id === id);
      const value = level?.label;

      experienceToUpdate.jobLevel = {
        id,
        value,
      };
    } else if (name === 'discipline') {
      const id = fieldValue;
      const discipline = disciplines.find((discipline) => discipline.id === id);
      const value = discipline?.label;

      experienceToUpdate.discipline = {
        id,
        value,
      };
    } else if (name === 'industry') {
      const id = fieldValue;
      const industry = industries.find((industry) => industry.id === id);
      const value = industry?.label;

      experienceToUpdate.industry = {
        id,
        value,
      };
    } else {
      // @ts-expect-error FIXME
      experienceToUpdate[name] = value.value;
    }
  }

  updateLocalStorage(`professionalExperience`, professionalExperiences);
};
